import { render } from "./TripDescription.vue?vue&type=template&id=74fce7e7&scoped=true"
import script from "./TripDescription.vue?vue&type=script&lang=js"
export * from "./TripDescription.vue?vue&type=script&lang=js"

import "./TripDescription.vue?vue&type=style&index=0&id=74fce7e7&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fce7e7"]])

export default __exports__